import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Checkbox, IconButton, TextField, CircularProgress, Box, Typography, Tooltip, FormControl, RadioGroup, Radio, FormControlLabel, Drawer, Stack, Button, Autocomplete } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Colors } from "../../../Styles/Colors";
import { ImagePaths } from "../../../Utility/ImagePaths";
import { CommonGridToolBarWithFilterText } from "../../../Components/Common Components/CommonComponents";
import ToastMsg from "../../../Components/ToastMsg/ToastMsg";
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import RestAPIService from "../../../Utility/Services/RestAPIService";
import StoreStockViewPop from "./StoreStockViewPop";
import { CheckAccessFunc, formatDate } from "../../../Components/CommonFunctions/CommonFunctions";
import CommonDatePicker from "../../../Components/Common Components/CommonDatePicker";
import { DateTime } from 'luxon';

function StoreStockCorrection() {
  const datelist = {
    stklocation: null,
    show_zero_stk: false,
    BatchNo: ""
  }

  const [page, setpage] = useState(0);
  const [pageSize, setpageSize] = useState(10);
  const [CheckBoxList, setCheckBoxList] = useState([]);
  const [delIDs, setdelIDs] = useState([]);
  const [openPop, setOpenPop] = useState(false);
  const [productList, setproductList] = useState([]);
  const [isloader, setisloader] = useState(false);
  const [DrugTypeFilter, setDrugTypeFilter] = useState("active");
  const [selectedData, setSelectedData] = useState(null);
  const [errorMsg, seterrorMsg] = useState(false);
  const [errorMsgText, seterrorMsgText] = useState('');
  const [successMsg, setsuccessMsg] = useState(false);
  const [successMsgText, setsuccessMsgText] = useState('');
  const [SubLocationList, setSubLocationList] = useState([]);
  const [filterOpen, setFilterOpen] = useState(false);
  const [filterData, setfilterData] = useState(datelist);



  useEffect(() => {
    getProductStockList()
    getSubLocationList()
  }, [DrugTypeFilter])

  useEffect(() => {
    if (selectedData) {
      setOpenPop(true)
    }
  }, [selectedData])

  const errorMessage = (msg) => {
    seterrorMsgText(msg)
    seterrorMsg(true)
  }
  const successMessage = (msg) => {
    setsuccessMsgText(msg)
    setsuccessMsg(true)
  }

  const getProductStockList = () => {
    try {
      setisloader(true)
      RestAPIService.getAll(`${Serviceurls.STORE_PRODUCT_STOCK_LIST}?&sublocation_id=${filterData?.stklocation?.id || ""}&include_zero=${filterData?.show_zero_stk ? true : false}&batch_no=${filterData?.BatchNo || ""}`)
        .then((response) => {
          if (response.data.status === 'success') {
            setproductList(response.data.data || [])
            setisloader(false)
          }
        }).catch(e => {
          setisloader(false)
          if (e?.response?.data?.status === 'fail') {
            errorMessage(e.response.data.message)
          } else {
            errorMessage(e.message)
          }
        })
    } catch (e) {
      setisloader(false)
      errorMessage(e.message)
    }
  }

  const getSubLocationList = (storeObj = null) => {
    try {
      RestAPIService.getAll(Serviceurls.SUB_LOCATION_CREATION_MASTER + '?only_store=true')
        .then((response) => {
          if (response.data.status === 'success') {
            setSubLocationList(response.data.data || [])
          }
        }).catch(e => {
          if (e?.response?.data?.status === 'fail') {
            errorMessage(e.response.data.message)
          } else {
            errorMessage(e.message)
          }
        })
    } catch (e) {
      errorMessage(e.message)
    }
  }

  const msgClose = () => {
    seterrorMsg(false);
    seterrorMsgText('');
    setsuccessMsg(false);
    setsuccessMsgText('');
  }

  const FilterDate = (from, to, index) => {
    setfilterData({ ...filterData, fromDate: from, toDate: to, dateIndex: index })
  }

  const closePopup = (apiCall = false) => {
    setOpenPop(false);
    setSelectedData(null);
    console.log(apiCall)
    if (apiCall) {
      getProductStockList()
    }
  }

  const renderFilterScreen = () => {
    return (
      <Box component={"div"} className='eMed_rts_filter_container'>
        <Box component={"div"} className='eMed_filter_Top'>
          <Typography variant='h6' fontWeight={600}>Filter</Typography>
          <Tooltip>
            <Button onClick={() => { setFilterOpen(false) }}>
              <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_Canteen_CloseImg' />
            </Button>
          </Tooltip>
        </Box>
        <Box className='eMed_rts_middle'>
          <Box className='eMed_rts_dropdown'>
            <Autocomplete
              disableClearable
              size='small'
              value={filterData.stklocation ? filterData.stklocation : null}
              options={SubLocationList}
              getOptionLabel={(option) => (typeof (option) === 'string') ? option : option?.sublocation_name}
              onChange={(event, newValue) => {
                setfilterData({ ...filterData, stklocation: newValue })
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={'Select SubLoction'}
                />
              )} />
          </Box>
          <Box className='eMed_rts_dropdown'>
            <TextField
              size='small'
              sx={{ width: '20dvw' }}
              label={'Batch Number'}
              value={filterData.BatchNo ? filterData.BatchNo : ''}
              onChange={(e) => {
                setfilterData({ ...filterData, BatchNo: e.target.value })
              }} />
          </Box>
          <Box className='eMed_rts_dropdown'>
            <FormControlLabel control={<Checkbox size='small' checked={filterData?.show_zero_stk} onChange={(e) => { setfilterData({ ...filterData, show_zero_stk: e.target.checked }) }} />} label="Show Zero Stock Products" />
          </Box>
        </Box>
        <Box>
          <Stack spacing={2} direction="row" justifyContent={'center'}>
            <Button size='small' variant='outlined' className='eMed_Canteen_BtnText' onClick={() => {
              setfilterData({
                stklocation: null,
                show_zero_stk: false,
                BatchNo: ""
              })
            }}>Clear</Button>
            <Button size='small' variant='contained' className='eMed_Canteen_BtnText' onClick={() => {
              getProductStockList()
              setFilterOpen(false)
            }}>Search</Button>
          </Stack>
        </Box>
      </Box>
    )
  }

  const closeFilter = () => {
    setFilterOpen(false);
  }


  const tableView = () => {
    try {
      const gridToolBar = () => {
        return (
          <Box>
            <CommonGridToolBarWithFilterText isDelete={delIDs?.length > 0} />
          </Box>
        )
      }

      productList?.forEach((element, index) => element.sno = index + 1)
      const columns = [
        {
          field: 'product_code', headerName: 'Product Code', flex: 0.07,
          renderCell: (params) => (<Box component={'div'}>{params?.row?.product_code || '-'}</Box>)

        },
        {
          field: 'product_name', headerName: 'Product Name', flex: 0.07,
          renderCell: (params) => (params.row.product_name ? params.row.product_name?.length > 12 ?
            <Tooltip placement="top" title={params.row.product_name}><Typography fontSize={'0.9vw'}>{params.row.product_name?.slice(0, 12) + '...'}</Typography></Tooltip> :
            <Typography fontSize={'0.9vw'}>{params.row.product_name || '-'}</Typography> : '-')
        },
        {
          field: 'common_name', headerName: 'Common Name', flex: 0.07,
          renderCell: (params) => (params.row.common_name ? params.row.common_name?.length > 12 ?
            <Tooltip placement="top" title={params.row.common_name}><Typography fontSize={'0.9vw'}>{params.row.common_name?.slice(0, 12) + '...'}</Typography></Tooltip> :
            <Typography fontSize={'0.9vw'}>{params.row.common_name || '-'}</Typography> : '-')

        },
        {
          field: 'batch_no', headerName: 'Batch No', flex: 0.07,
          renderCell: (params) => (params.row.batch_no ? params.row.batch_no?.length > 12 ?
            <Tooltip placement="top" title={params.row.batch_no}><Typography fontSize={'0.9vw'}>{params.row.batch_no?.slice(0, 12) + '...'}</Typography></Tooltip> :
            <Typography fontSize={'0.9vw'}>{params.row.batch_no || '-'}</Typography> : '-')
        },
        {
          field: 'manufacturer_name', headerName: 'Manufacture Name', flex: 0.07,
          renderCell: (params) => (params.row.manufacturer_name ? params.row.manufacturer_name?.length > 12 ?
            <Tooltip placement="top" title={params.row.manufacturer_name}><Typography fontSize={'0.9vw'}>{params.row.manufacturer_name?.slice(0, 12) + '...'}</Typography></Tooltip> :
            <Typography fontSize={'0.9vw'}>{params.row.manufacturer_name || '-'}</Typography> : '-')

        },
        {
          field: 'expiry_date', headerName: 'Exp Date', flex: 0.07,
          renderCell: (params) => (<Box component={'div'}>{params?.row?.expiry_date ? formatDate(params?.row?.expiry_date, true) : '-'}</Box>)
        },
        {
          field: 'rol_quantity', headerName: 'ROL', flex: 0.07,
          renderCell: (params) => (<Box component={'div'}>{params?.row?.rol_quantity || '-'}</Box>)

        },
        {
          field: 'roq_quantity', headerName: 'ROQ', flex: 0.07,
          renderCell: (params) => (<Box component={'div'}>{params?.row?.roq_quantity || '-'}</Box>)

        },
        {
          field: 'gst_percentage', headerName: 'GST %', flex: 0.07,
          renderCell: (params) => (<Box component={'div'}>{params?.row?.gst_percentage || '-'}</Box>)

        },
        {
          field: 'hsn_code', headerName: 'HSN Code', flex: 0.07,
          renderCell: (params) => (<Box component={'div'}>{params?.row?.hsn_code || '-'}</Box>)

        },
        {
          field: 'stock_in_quantity', headerName: 'Stock Quantity', flex: 0.07,
          renderCell: (params) => (<Box component={'div'}>{params?.row?.stock_in_quantity || '-'}</Box>)

        },
        {
          field: 'mrp_per_quantity', headerName: 'MRP/Qty', flex: 0.07,
          renderCell: (params) => (<Box component={'div'}>{params?.row?.mrp_per_quantity || '-'}</Box>)

        },
        {
          field: 'action', headerName: 'Action', flex: 0.07,
          renderCell: (params) => (
            <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
              {CheckAccessFunc("Store", "Inventory", "Stock Correction", null, "Tab")?.editAccess ? <Tooltip title={"View Product"} placement="top" arrow>
                <IconButton emed_tid={'st_view_' + params?.id} className='eMed_usrconf_btn' onClick={() => { setSelectedData(params?.row) }}>
                  <img src={ImagePaths.LabEditButton.default} alt="View" style={{ width: '1.5vw', height: '1.5vw' }} />
                </IconButton>
              </Tooltip> : null}
            </Box>
          )

        },
      ];
      return (
        <Box sx={{ height: '70vh', marginTop: '.5vw', backgroundColor: 'white' }}>
          <DataGrid
            // checkboxSelection
            // selectionModel={CheckBoxList}
            // onSelectionModelChange={(id) => handleTableCheckbox(id)}
            rows={productList}
            columns={columns}
            getRowId={(row) => row['sno']}
            page={page}
            pageSize={pageSize}
            localeText={{
              toolbarColumns: "",
              toolbarDensity: "",
              toolbarExport: "",
              toolbarFilters: "",
              toolbarExportPrint: ""
            }}
            components={{
              Toolbar: gridToolBar,
              NoRowsOverlay: () => (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                  {'No Records To Be Shown'}
                </Box>
              )
            }}
            onPageChange={(newPage) => { setpage(newPage) }}
            onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
            rowsPerPageOptions={[10, 20, 30]}
            pagination
            headerHeight={40}
            density='standard'
            disableSelectionOnClick
            loading={isloader}
          />
        </Box>
      )
    } catch (e) {

    }
  }

  return (
    <Box sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
      <Box display={'flex'} justifyContent={'flex-end'} flexDirection={'row'} alignItems={'center'}>
        <IconButton onClick={() => { setFilterOpen(true) }}>
          <img style={{ width: '2vw', height: '2vw' }} src={ImagePaths.Filter.default} alt='filter' />
        </IconButton>
      </Box>
      <Box>
        {tableView()}
      </Box>
      <Drawer
        anchor={'right'}
        open={filterOpen}
        ModalProps={{ onBackdropClick: closeFilter }}
      >
        {renderFilterScreen()}
      </Drawer>
      {openPop ? <StoreStockViewPop open={openPop} onClose={closePopup} forEdit={true} selectedData={selectedData} errorMessage={errorMessage.bind(this)} successMessage={successMessage.bind(this)} /> : null}
      {errorMsg ?
        <ToastMsg
          severity={'error'}
          msg={errorMsgText}
          msgPop={msgClose.bind(this)}
        />
        : null}
      {successMsg ?
        <ToastMsg
          severity={'success'}
          msg={successMsgText}
          msgPop={msgClose.bind(this)}
        />
        : null}
    </Box>
  );
};

export default StoreStockCorrection;


